import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { loadBaseMover } from "tsparticles-move-base";
import { loadCircleShape } from "tsparticles-shape-circle";
import { loadColorUpdater } from "tsparticles-updater-color";
import { loadOpacityUpdater } from "tsparticles-updater-opacity";
import { loadOutModesUpdater } from "tsparticles-updater-out-modes";
import { loadSizeUpdater } from "tsparticles-updater-size";
import { options } from "./options";
export function loadStarsPreset(_x) {
  return _loadStarsPreset.apply(this, arguments);
}

function _loadStarsPreset() {
  _loadStarsPreset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(engine) {
    var refresh,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            refresh = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;
            _context.next = 3;
            return loadBaseMover(engine, false);

          case 3:
            _context.next = 5;
            return loadCircleShape(engine, false);

          case 5:
            _context.next = 7;
            return loadColorUpdater(engine, false);

          case 7:
            _context.next = 9;
            return loadOpacityUpdater(engine, false);

          case 9:
            _context.next = 11;
            return loadOutModesUpdater(engine, false);

          case 11:
            _context.next = 13;
            return loadSizeUpdater(engine, false);

          case 13:
            _context.next = 15;
            return engine.addPreset("stars", options, refresh);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadStarsPreset.apply(this, arguments);
}